import React from "react";
import { DocumentTemplateTable } from "./DocumentTemplateTable";
import { Button, Grid, LinearProgress, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import { useDocumentTempData } from "../../../projectManagementQueries";

export const DocumentTemplateList = () => {
  const {
    error: errorProjects,
    data: Documentdata,
    isLoading: isLoadingProjects,
    isError: isErrorProjects,
    refetch,
  } = useDocumentTempData();

  console.log("Data : ", Documentdata);

  const history = useHistory();
  const handleUploadNewReportTemplate = () => {
    history.push(`/reports/report_document/report_document_upload/`);
  };

  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        style={{ marginBottom: 10 }}
      >
        <Grid item>
          <Typography variant="h5">Report Template Details</Typography>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={handleUploadNewReportTemplate}
          >
            Upload New Report Template
          </Button>
        </Grid>
      </Grid>
      {isLoadingProjects ? (
        <>
          <Typography>Loading...</Typography>
          <LinearProgress />
        </>
      ) : (
        Documentdata?.results?.length > 0 && (
          <DocumentTemplateTable
            data={Documentdata.results}
            refetch={refetch}
          />
        )
      )}{" "}
    </>
  );
};
